import React, { useState } from 'react';
import { updateCalificacionTarea } from '../services/tareasService';
import './styles/components.css';

const CalificarTareaButton = ({ tareaId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selected, setSelected] = useState('');
  const [comentario, setComentario] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleOpenModal = () => {
    setIsModalOpen(true);
    setError('');
    setSuccess('');
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelected('');
    setComentario('');
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selected) {
      setError('Seleccione una calificación');
      return;
    }
    if (!comentario.trim()) {
      setError('Ingrese un comentario');
      return;
    }
    setLoading(true);
    const resp = await updateCalificacionTarea(tareaId, parseInt(selected), comentario.trim());
    if (resp.success) {
      setSuccess('Tarea calificada');
      setTimeout(() => {
        handleCloseModal();
      }, 1000);
    } else {
      setError(resp.message);
    }
    setLoading(false);
  };

  return (
    <>
      <button className="edit-btn" onClick={handleOpenModal} style={{ fontSize: '14px' }}>
        Calificar
      </button>
      {isModalOpen && (
        <div className="modal-permisos-backdrop">
          <div className="modal-permisos-container" style={{ minWidth: 350, maxWidth: 400 }}>
            <div className="modal-permisos-header">
              <h2 className="modal-permisos-title">Calificar Tarea</h2>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-permisos-body">
                {error && <div style={{ color: 'red', marginTop: '8px' }}>{error}</div>}
                {success && <div style={{ color: 'green', marginTop: '8px' }}>{success}</div>}
                <div className="form-group">
                  <label htmlFor="calificacion">Calificación:</label>
                  <select
                    id="calificacion"
                    value={selected}
                    onChange={e => setSelected(e.target.value)}
                    style={{ width: '100%', padding: '8px', marginTop: '8px', borderRadius: '4px', border: '1px solid #e0e0e0' }}
                  >
                    <option value="">Seleccione una calificación</option>
                    <option value="1">1 - Muy malo</option>
                    <option value="2">2 - Malo</option>
                    <option value="3">3 - Regular</option>
                    <option value="4">4 - Bueno</option>
                    <option value="5">5 - Excelente</option>
                  </select>
                </div>
                <div className="form-group" style={{ marginTop: '16px' }}>
                  <label htmlFor="comentario">Comentario:</label>
                  <textarea
                    id="comentario"
                    value={comentario}
                    onChange={e => setComentario(e.target.value)}
                    placeholder="Ingrese su comentario sobre la tarea..."
                    style={{ 
                      width: '100%', 
                      padding: '8px', 
                      marginTop: '8px', 
                      borderRadius: '4px', 
                      border: '1px solid #e0e0e0',
                      minHeight: '80px',
                      resize: 'vertical'
                    }}
                    required
                  />
                </div>
              </div>
              <div className="modal-permisos-actions">
                <button type="button" onClick={handleCloseModal} className="modal-permisos-btn cancelar">
                  Cancelar
                </button>
                <button type="submit" className="edit-btn" disabled={loading}>
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default CalificarTareaButton; 